import React from 'react'; //useState,
import { useTranslation } from 'react-i18next';
import BgAgenda from './HeaderVideo.png'
import CVoliverPanichi from '../../CardVideo/CardVideo2'
import CvFrancoisJetteur from '../../CardVideo/CardVideo3'
import VideoReneDaniel from '../../CardVideo/CardVideoReneDaniel.js'
import VideoMareekMartine from '../../CardVideo/VideoMartineMaarek'
// import CardVideoCB from '../../../api/CardVideo' 

const Videos = () => {

    // const [activeApi, setActiveApi] = useState(false)

//     useEffect(() => {
        
//       }, []);

//      const elie = async () => {
//         const result = await CardVideoCB()
//         const dataJSON = JSON.parse(result).Table[0]
//         console.log(dataJSON)
        
//         }

//  <div>{elie}</div>

    const { t } = useTranslation();
       
    return (
        <div >

            <div  style={{backgroundImage: `url(${BgAgenda})`, height: 400+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover'}} className="text-center h1 text-bordeaux  p-2">
                
                {t('CardVideo.Videos')}
            </div>


            
           
            
            





            <div className="container">

                <div>
                    <CVoliverPanichi />
                </div>  

                <div>
                    <CvFrancoisJetteur />
                </div>  

                <div>
                    <VideoReneDaniel />
                </div>  
                
                <div>
                    <VideoMareekMartine />
                </div>  

            </div>
            
        </div>
    )

}

export default Videos